// extracted by mini-css-extract-plugin
export var base = "_3m-0";
export var updateBanner = "_3m-1";